import React, { useState } from "react"
import { useParams } from "react-router"
import "../../CenterAdmin/AddNewReferral/AddNewReferral.scss"
import { saveFormTemplateSystemAdmin } from "../../../../core/services/api"
import Button from "react-bootstrap/esm/Button"
import Toast from "components/Toast"
import { useSelector } from "react-redux"
/**
 * Renders form template fields editor.
 *
 * @returns
 */
function EditFormsAndTemplatesV2({ formTemplate }: any) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { id } = useParams<{ id: string }>()
  const readOnlys = useSelector((state: any) => state?.user?.readOnly)


  //const [formTemplate, setFormTemplate] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()

  /**
   * Gets triggered when form template id is updated (on component load) via params.
   */
  console.log(formTemplate, "formTemplate in edit Form and Template");

  // useEffect(() => {
  //   setIsLoading(true)
  //   getFormTemplateById(id)
  //     .then((res: any) => {
  //       setFormTemplate(res)
  //       setIsLoading(false)
  //     })
  //     .catch((err: any) => {
  //       console.log(err, "error")
  //       setIsLoading(false)
  //     })
  // }, [id])




  //Download Functionality
  const handleDownloadClick = (jsonData: any, part: any, formTemplate: any) => {

    var blob = new Blob([JSON.stringify(jsonData)], {
      type: "application/json",
    })
    var url = URL.createObjectURL(blob)
    var link = document.createElement("a")
    link.href = url
    link.download = formTemplate?.type == 'CANCER' ? `${formTemplate?.subType}_Part${part}.json` : `${formTemplate?.subType}.json`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  //Upload Functionality

  const [codeContent, setCodeContent] = useState("")
  const [openTextareaId, setOpenTextareaId] = useState("")
  const handleTextareaChange = (event: any) => {
    setCodeContent(event.target.value)
  }


  const handleFileUpload = (id: any, formTemplate: any, part: any) => {
    try {
      const jsonContent = JSON.parse(codeContent);
      if (typeof jsonContent === 'object' && jsonContent !== null && Object.keys(jsonContent).length > 0) {
        const data = [{
          id: formTemplate?.id,
          type: formTemplate?.type,
          subType: formTemplate?.subType,
          centers: formTemplate?.centers,
          dataToUpdate: [
            {
              part: part,
              json: jsonContent
            }
          ],
          dataToDelete: [
            0
          ],
          writeRights: formTemplate?.writeRights,
          readRights: formTemplate?.readRights,
        }];
        console.log(data, "data");
        // setIsLoading(true)
        saveFormTemplateSystemAdmin(data)
          .then((res) => {
            setIsLoading(false)
            toggleDisplayToast({ text: "Form Template Added Successfully", type: "success" });
          })
          .catch((err) => {
            setIsLoading(false)
            toggleDisplayToast({ text: "Cannot Add Form Template", type: "error" });
          });
      } else {
        setIsLoading(false)
        toggleDisplayToast({ text: "Invalid JSON content", type: "error" });
      }
    } catch (error) {
      setIsLoading(false)
      toggleDisplayToast({ text: "Invalid JSON content", type: "error" });
    }
  };


  const handleOpenTextarea = (id: any) => {
    setOpenTextareaId(id)
  }

  const handleCloseTextarea = (id: any) => {
    setOpenTextareaId("")
    setCodeContent("")
  }

  console.log(formTemplate, "form Template");
  return (
    <div className="add-new-referral-container">
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      {/* <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/forms-v2")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
       
      </div> */}
      <div className="add-new-referral-details">
        <>
          <div className="row nameDetails">
            <div className="col-3">
              <label className="textlabel">Name:</label>
            </div>
            <div className="col-3">
              <label className="textlabel">{formTemplate?.subType}</label>
            </div>
          </div>

          <div className="row nameDetails">
            <div className="col-3">
              <label className="textlabel">Type:</label>
            </div>
            <div className="col-3">
              <label className="textlabel">{formTemplate?.type}</label>
            </div>
          </div>

          {/* <div className="row nameDetails">
            <div className="col-3">
              <label className="textlabel">Centers:</label>
            </div>
            <div className="col-3">
              <label className="textlabel">
                {formTemplate?.centers?.join(",")}
              </label>
            </div>
          </div> */}
          {formTemplate?.type !== "CANCER" && (
            <>
              <div className="row nameDetails">
                <div className="col-3">
                  <label className="textlabel">Read Permission:</label>
                </div>
                <div className="col-9">
                  <label className="textlabel">
                    <span style={{ wordBreak: 'break-all' }}>{formTemplate?.readRights?.join(",")}</span>
                  </label>
                </div>
              </div>

              <div className="row nameDetails">
                <div className="col-3">
                  <label className="textlabel">Write Permission:</label>
                </div>
                <div className="col-3">
                  <label className="textlabel">
                    {formTemplate?.writeRights?.join(",")}
                  </label>
                </div>
              </div>
            </>
          )}


          <div className="row nameDetails">
            <div className="col-3">
              <label className="textlabel">Service Name:</label>
            </div>
            <div className="col-9">
              <label className="textlabel">
                {formTemplate?.servicesIds?.map((id: any) => formTemplate?.serviceIdName[id])?.join(", ")}

              </label>
            </div>
          </div>

          <div className="row nameDetails">
            <div className="col-3">
              {formTemplate?.type === "CANCER" ? <><label className="textlabel">Form Parts:</label></> : <><label className="textlabel">Form:</label></>}
            </div>
            <div style={{ paddingTop: "20px" }}>
              {formTemplate?.partNos &&
                formTemplate?.data.map((data: any, i: number) => {
                  const isOpen = openTextareaId === data?.part
                  return (
                    <div className="form-div">
                      {data.part ? (
                        <strong style={{ paddingRight: "10px" }}>
                          {data.part}
                        </strong>
                      ) : (
                        <></>
                      )}
                      &nbsp;
                      <Button
                        style={{
                          height: "32px", cursor: readOnlys ? 'not-allowed' : 'pointer', backgroundColor: readOnlys && '#e9ecef', borderColor: readOnlys && '#e9ecef',
                          color: readOnlys && 'rgb(12 13 15 / 26%)'
                        }}
                        onClick={() => {
                          if (readOnlys) return null
                          handleDownloadClick(data.json,
                            data.part, formTemplate)
                        }}
                      >
                        Download JSON
                      </Button>
                      &nbsp; &nbsp;
                      <div>
                        {!isOpen && (
                          <>
                            <Button
                              style={{
                                height: "32px", cursor: readOnlys ? 'not-allowed' : 'pointer', borderColor: readOnlys && '#e9ecef', backgroundColor: readOnlys && '#e9ecef',
                                color: readOnlys && 'rgb(12 13 15 / 26%)'
                              }}
                              onClick={() => {
                                if (readOnlys) return null
                                handleOpenTextarea(data?.part)
                              }}
                            >
                              Upload
                            </Button>
                          </>
                        )}
                        {isOpen && (
                          <div>
                            <textarea
                              className="paste-code"
                              value={codeContent}
                              onChange={handleTextareaChange}
                              placeholder="Paste your code here"
                              rows={10}
                              cols={50}
                            ></textarea>
                            <div style={{ display: "flex", columnGap: "10px" }}>
                              <Button
                                onClick={() => handleFileUpload(id, formTemplate, data.part)}
                                variant="success"
                              >
                                Upload JSON
                              </Button>
                              <Button
                                onClick={() => handleCloseTextarea(data?.part)}
                                variant="danger"
                              >
                                Close
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                      &nbsp;
                      {/* <Link
                        to={{
                          pathname: "/view-form",
                          state: state,
                        }}
                      >
                        View
                      </Link>
                      &nbsp; &nbsp;
                      <Link
                        to={{
                          pathname: "/edit-form-json",
                          state: state,
                        }}
                      >
                        Edit
                      </Link> */}
                    </div>
                  )
                })}
            </div>

            <div>

            </div>
          </div>
        </>
      </div>

      {/* <ReadAndWriteTable
        formTemplate={formTemplate}
      /> */}
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  )
}
export default EditFormsAndTemplatesV2
